import { render, staticRenderFns } from "./DiscountPrice.vue?vue&type=template&id=3349d9de"
import script from "./DiscountPrice.vue?vue&type=script&lang=js"
export * from "./DiscountPrice.vue?vue&type=script&lang=js"
import style0 from "./DiscountPrice.vue?vue&type=style&index=0&id=3349d9de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./DiscountPrice.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports